<template>
    <div class="DocumentDataReviewBackgroundIcon" :class="`DocumentDataReviewBackgroundIcon--${size}`">
        <EidIcon :icon-src="icon" />
    </div>
</template>

<style lang="scss">
.DocumentDataReviewBackgroundIcon {
    border-radius: 0.25rem;
    background-color: rgba(43, 181, 151, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: var(--eidTrustGreen);
    }

    &--normal {
        width: 32px;
        height: 32px;

        svg {
            width: 16px;
            height: 16px;
        }
    }

    &--sm {
        width: 28px;
        height: 28px;

        svg {
            width: 14px;
            height: 14px;
        }
    }

    &--xs {
        width: 20px;
        height: 20px;

        svg {
            width: 12px;
            height: 12px;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    export default defineComponent({
        name: 'DocumentDataReviewBackgroundIcon',
        components: {
            EidIcon,
        },
        props: {
            icon: {
                type: Object as PropType<IconDefinition>,
                required: true,
            },
            size: {
                type: String as PropType<'normal' | 'sm' | 'xs'>,
                default: 'normal',
            },
        },
    });
</script>
